import { createStyles, makeStyles, Theme, Typography } from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      color: '#595959',
      fontFamily: '"Exo 2"',
      fontSize: 14,
      fontWeight: 'bold',
    },
  }),
);

export interface IPageSubtitle {
  subtitle: string
}

export default ({ subtitle }: IPageSubtitle) => {
  const classes = useStyles();

  return (
    <Typography classes={{ root: classes.root }}>
      { subtitle }
    </Typography>
  )
}